import {Injectable} from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor
} from '@angular/common/http';

import {Observable, Subject} from 'rxjs';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  constructor() {
    if (localStorage.getItem('token')) {
      this.token = localStorage.getItem('token');
    }
    this.tokenSubject = new Subject();
    this.tokenSubject
      .asObservable()
      .subscribe(t => {
        this.token = t;
      });
  }

  public tokenSubject: Subject<string>;
  public token: string;

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // const token = localStorage.getItem('token');

    if (this.token) {
      request = request.clone({
        setHeaders: {
          Authorization: `Bearer ${this.token}`
        }
      });
    }
    return next.handle(request);
  }

  refreshToken(token: string) {
    this.tokenSubject.next(token);
  }
}
